import { BaseElementBounds, Beam2D } from "../../../models/Construction";
import { Rect, Transformer } from "react-konva";
import { BaseComponentProps, BaseElementWrapper } from "./EditorWrapper";
import { ElementInteractionCallbacks, FLOOR_PLAN_COLORS } from "./Elements";
import { Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import Konva from 'konva';
import { KonvaEventObject } from "konva/lib/Node";

interface BeamComponentProps extends BaseComponentProps<Beam2D> {
  onMouseMove?: (e: KonvaEventObject<MouseEvent>) => void;
}

export const BeamComponent: React.FC<BeamComponentProps> = ({
  element,
  scale,
  thicknessMultiplier = 1,
  isSelected = false,
  isHovered = false,
  onSelect,
  onDelete,
  onUpdate,
  onResizeStart,
  onMouseMove,
}) => {

  const centerX = element.center_point.x * scale;
  const centerY = element.center_point.y * scale;
  const length =  element.length * scale;
  const width = element.width * scale * thicknessMultiplier;
  const angle = element.rotation_z || 0;

  const shapeRef = useRef<Konva.Rect>(null)
  const trRef = useRef<Konva.Transformer>(null)
  const bounds: BaseElementBounds = {
    centerX,
    centerY,
    width: length,
    height: width,
    angle,
  }

  useEffect(() => {
    if (isSelected && trRef.current && shapeRef.current) {
      trRef.current.nodes([shapeRef.current])
      trRef.current.getLayer()?.batchDraw()
    } else if (!isSelected && trRef.current && shapeRef.current) {
      trRef.current.nodes([])
      trRef.current.getLayer()?.batchDraw()
    }
  }, [isSelected])

  const callbacks: ElementInteractionCallbacks<Beam2D> = {
    onSelect,
    onDelete,
    onUpdate,
    onResizeStart,
  }

  const onTransformEnd = (e:any) => {

    let updatesTmp: any = {};
    updatesTmp = {
      center_point: { x: e.target.x()/scale, y: e.target.y()/scale, z: e.target.attrs.rotation },
    };

    const node = shapeRef.current;
    if(node){
      const scaleX = node.scaleX();
      const scaleY = node.scaleY();

      const width = Math.max(node.width() * scaleX) / scale
      const height = Math.max(node.height() * scaleY)

      node.scaleX(1);
      node.scaleY(1);

      let updates: any = {};
      updates = {
        center_point: { x: node.x()/scale, y: node.y()/scale, z: node.attrs.rotation },
        length: width,
        width: height,
      };
      onUpdate?.(element.id,element.type,updates);
    }
  }

  const onDragEnd = (e: any) => {
      let updates: any = {};
      updates = {
        center_point: { x: e.target.x()/scale, y: e.target.y()/scale, z: e.target.attrs.rotation },
      };
      onUpdate?.(element.id,element.type,updates)
  }

  const customColors = {
    normal: FLOOR_PLAN_COLORS.BEAMS,
    hover: "#CD853F",
  };
  
  return (
    <BaseElementWrapper
      element={element}
      bounds={bounds}
      scale={scale}
      isSelected={isSelected}
      isHovered={isHovered}
      callbacks={callbacks}
      customColors={customColors}
      elementType='beam'
    >
      {({ styling, behaviors, dragProps }) => (
        <Fragment>
          <Rect
            ref={shapeRef}
            x={centerX}
            y={centerY}
            width={length}
            height={width}
            offsetX={length / 2}
            offsetY={width / 2}
            {...styling}
            {...dragProps}
            rotation={angle}
            draggable
            onClick={behaviors.handleClick}
            onTap={behaviors.handleClick}
            onMouseEnter={behaviors.handleMouseEnter}
            onMouseLeave={behaviors.handleMouseLeave}
            onDragEnd={onDragEnd}
            onTransformEnd={onTransformEnd}
            cursor={"pointer"}
          />
          <Transformer
            rotateEnabled={false}
            ref={trRef}
            flipEnabled={true}
          />
          <Transformer rotateEnabled={false} ref={trRef} flipEnabled={true} />
        </Fragment>
      )}
    </BaseElementWrapper>
  )
}
